/**
 * Generic SSE stream reader for fetch responses that used 'text/event-stream'.
 * Accepts a map of event handlers keyed by event name.
 * Each handler receives parsed JSON data. If it returns truthy, streaming stops.
 */
export async function streamSSE(response, handlers = {}) {
  if (!response?.body) throw new Error('Missing response body for SSE stream');
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let sepIndex;
    while ((sepIndex = buffer.indexOf('\n\n')) !== -1) {
      const block = buffer.slice(0, sepIndex);
      buffer = buffer.slice(sepIndex + 2);
      if (!block.trim()) continue;
      let event = null; let dataLine = '';
      for (const line of block.split('\n')) {
        if (line.startsWith('event: ')) event = line.substring(7).trim();
        else if (line.startsWith('data: ')) dataLine = line.substring(6).trim();
      }
      if (event && dataLine) {
        try {
          const parsed = JSON.parse(dataLine);
          const handler = handlers[event];
          if (typeof handler === 'function') {
            const stop = await handler(parsed);
            if (stop) return;
          }
        } catch (e) {
          console.warn('Failed to parse SSE event data', e, dataLine);
        }
      }
    }
  }
}
